// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.resync-table[data-v-34ad9013] th.sortable.text-center::before {\n  content: \"\";\n  display: inline-block;\n  width: 18px;\n}\n\n", ""]);
// Exports
module.exports = exports;
